// Utils/FetchUserRewardData.js

import UserRewardStructure from "../Constants/UserRewardStructure.js"; // Adjust path if needed

export const FetchUserRewardData = async () => {
  try {
    const response = await fetch("/api/mock/Settings/UserRewardMockData.json");
    const data = await response.json();

    if (!data || typeof data !== "object") {
      console.warn("Expected user reward data to be an object");
      return UserRewardStructure;
    }

    const formattedData = {
      ...UserRewardStructure,
      ...data,
      profiles: data.profiles?.map((p) => ({
        profileId: p.profileId || "",
        profileUUID: p.profileUUID || "",
        postCount: p.postCount || 0,
        admirerCount: p.admirerCount || 0,
        posts: p.posts?.map((post) => ({
          postId: post.postId || "",
          postUUID: post.postUUID || "",
          totalLikes: post.totalLikes || 0,
          totalShares: post.totalShares || 0,
          totalComments: post.totalComments || 0,
          totalSuggest: post.totalSuggest || 0,
          impressions: {
            gainedImpressions: post.impressions?.gainedImpressions || 0,
          },
        })) || [],
      })) || [],
      coinHistory: data.coinHistory || [],
      activityTimeline: data.activityTimeline || [],
    };

    return formattedData;
  } catch (error) {
    console.error("Error fetching user reward data:", error);
    return UserRewardStructure;
  }
};
